import { ArrowLeftIcon, XIcon } from '@phosphor-icons/react'

import { Drawer } from '@/components/primitives/Drawer/Drawer'
import { cn } from '@/lib/utils'

import type { Dispatch, SetStateAction } from 'react'

export const SubMenuHeader = ({
  currentMenu,
  setShow,
  setCurrentMenu,
}: {
  currentMenu: string | null
  setShow: Dispatch<SetStateAction<boolean>>
  setCurrentMenu: Dispatch<SetStateAction<string | null>>
}) => {
  return (
    <div className="flex flex-col gap-8">
      <div className={cn('flex items-center justify-between')}>
        <button
          title="Back"
          onClick={() => {
            setShow(false)
          }}
        >
          <ArrowLeftIcon size={24} />
        </button>
        <div className="text-lg font-semibold">{currentMenu}</div>
        <Drawer.Close>
          <XIcon
            size={24}
            className="cursor-pointer text-grey-500"
            onClick={() => {
              setShow(false)
              setCurrentMenu(null)
            }}
          />
        </Drawer.Close>
      </div>
    </div>
  )
}
